import { render, staticRenderFns } from "./MatchSelect.vue?vue&type=template&id=068b80ac&scoped=true&"
import script from "./MatchSelect.vue?vue&type=script&lang=js&"
export * from "./MatchSelect.vue?vue&type=script&lang=js&"
import style0 from "./MatchSelect.vue?vue&type=style&index=0&id=068b80ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b80ac",
  null
  
)

export default component.exports